import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DRenta210IngresoServicios } from '@dian-api/renta210-ingreso';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DFormularioConfiguracion } from '../../configuracion/dformulario-configuracion';
import { ModalService } from '../../modal/services/modal.service';
import { GeneralService } from '../../services/general.service';
import { DVersionRutaFormato } from '@dian/api-formulario';
import { DContextoMuisca } from '@dian/core';
import { DLiquidacionRecibo, DRtaLiquidacionReciboPago } from '@dian-api/recibo-pago490';
import { DEnvioDataServicio } from '@dian-cmp/recibo-pago';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-cuotas',
  templateUrl: './cuotas.component.html',
  styleUrls: ['./cuotas.component.css']
})
export class CuotasComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  versionesRuta: Array<DVersionRutaFormato> = [];
  aniosCuota: number[] = [];
  datosUsuario: DContextoMuisca;
  private tiempo:Date;
  tabs: any = {
    elegirAnio: {value: true, title: 'Elegir año'},
    generarRecibo: {value: false, title: 'Generar Recibo'},
    previsualizar: {value: false, title: 'Previsualizar'},
    datosPago: {value: false, title: 'Datos de pago'},
  }
  currentTab = this.tabs.elegirAnio;
  contexto : DContextoMuisca;
  fecha: string;
  liquidacion: DLiquidacionRecibo;
  mensajeAntesGuardar: string;
  pagoPSE: boolean;
  tieneFirmaElectronica: boolean;
  formulario490 = new DRtaLiquidacionReciboPago;
  datosFirmaYGrancondtribuyente?: {esFirmaElectronica: boolean; granContribuyente: boolean};

  fechaPago = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  fechaHoy: Date = new Date();
  listCuotas: number[] = [];

  constructor(private modalService: ModalService,
    private  router: Router,
    private fb: FormBuilder,
    private dServicioRESTAPI: DRenta210IngresoServicios,
    private dNotificacionServicio: DNotificacionServicio,
    private generalService: GeneralService,
    private configuracionFormulario: DFormularioConfiguracion,
    private denvioData: DEnvioDataServicio,
    private datePipe: DatePipe) { 
      this.buildForm();
      this.obtenerVersionesRuta(this.configuracionFormulario.NUMERO_FORMULARIO);
      this.generalService.datosRespuesta$.subscribe(res =>{
        this.datosUsuario = res;
      })

      this.generalService.datosReciboPago$.subscribe(data => {
        this.contexto = data.contexto;
        this.fecha = data.fecha;
        this.liquidacion = data.liquidacion;
        this.mensajeAntesGuardar = data.mensajeAntesGuardar;
        this.pagoPSE = data.pagoPSE;
        this.tieneFirmaElectronica = data.tieneFirmaElectronica;
        this.changeTab('generarRecibo');
        if (this.liquidacion && parseInt(this.liquidacion.totalCuotas) > 1) {
          this.buildCuotas();
        }
      })

      this.denvioData.cambiaFlujo$.subscribe(data => {
        this.changeTab(data);
      })

      this.denvioData.reciboPago$.subscribe(res => {
        this.formulario490 = res ;
      })

      this.generalService.datosFirmaYTipoContribuyente$.subscribe(res =>{
        this.datosFirmaYGrancondtribuyente = res;
        if(!res.esFirmaElectronica || !res.granContribuyente){
          this.router.navigate(['/']);
        }
      })

      this.tiempo = new Date();               
      let tiempoReal = new Date();                    
      setInterval(()=>{
          tiempoReal.setSeconds(tiempoReal.getSeconds() + 1);
          this.tiempo = new Date(tiempoReal);                    
      }, 1000);
    }

    buildCuotas() {
      if (Number(this.liquidacion.totalCuotas) > 1) {
          for (let i = 1; i <= Number(this.liquidacion.totalCuotas); i++) {
            this.listCuotas.push(i);
          }
      }
    }

    sendCuota() {
      this.denvioData.enviarNumeroCuota(this.liquidacion.numCuota);
    }


  changeTab(tab: string) {
    const keys = Object.keys(this.tabs);
    keys.forEach(key => {
       this.tabs[key].value = false;
    })
    keys.forEach(key => {
      if (key === tab) {
        this.tabs[key].value = true;
        this.currentTab = this.tabs[key];
      }
    })
  }

  cambiarTab(event) {
  }


  ngOnInit() {
    if (!this.datosUsuario) {
      this.datosUsuario = this.generalService.getDatosUsuario();
    }
    if (!this.datosFirmaYGrancondtribuyente) {
      this.datosFirmaYGrancondtribuyente = this.generalService.getDatosFirmaYGranContribuyente();
      if(this.datosFirmaYGrancondtribuyente && (!this.datosFirmaYGrancondtribuyente.esFirmaElectronica || !this.datosFirmaYGrancondtribuyente.granContribuyente)){
        this.router.navigate(['/']);
      }
    }
  }

  buildForm(){
    this.form = this.fb.group({
      anio: new FormControl('', Validators.required),
    });
  }

  get formControls(){
    return this.form.controls;
  }

  public obtenerVersionesRuta(ideFormato:number){
    let observableVersionesFormato = this.dServicioRESTAPI.obtenerVersionesRuta(ideFormato);
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
    observableVersionesFormato.subscribe(
        res => { 
            this.versionesRuta = <Array<DVersionRutaFormato>>res;
            precargaProceso.close();
            this.aniosCuota = this.versionesRuta.filter(item => item.indPagoCuota === 'S').map(anio => anio.anioGravable);
        },
        error => {
            precargaProceso.close();
            this.dNotificacionServicio.mostrarDialogoError("No fue posible obtener las rutas de las versiones del formato");
        }
    );    
  }

  pagoPorCuotas(){
    this.generalService.enviarPagoCuotas({anioSeleccionado: this.form.controls.anio.value})
  }

  sendDate(){
    this.denvioData.enviarFechaPago(this.fechaPago);
  }

}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/cuotas/cuotas.component.ts